<script setup lang="ts">
import BaseSpinner from "./BaseSpinner.vue";

/**
 * global: indicator is shown globally in the center of the window (instead of inline)
 */
defineProps<{ global?: boolean; inverted?: boolean }>();
defineOptions({ inheritAttrs: false });
</script>

<template>
  <Teleport v-if="global" to="body">
    <div class="loading-indicator global">
      <BaseSpinner :inverted />
    </div>
  </Teleport>

  <div v-else class="loading-indicator">
    <BaseSpinner :inverted />
  </div>
</template>

<style lang="scss">
@use "@/styles/z-index";

.loading-indicator {
  pointer-events: none;

  &.global {
    position: fixed;
    inset: 48px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: z-index.$board;
  }
}
</style>
